// 订单管理
export default [
  {
    path: "/orderDetail",
    name: "orderDetail",
    component: () => import("@/views/orderManagement/orderDetail/orderDetail.vue"),
    meta: {
      title: "订单明细",
    },
  },
  {
    path: "/invoiceDetail",
    name: "invoiceDetail",
    component: () => import("@/views/orderManagement/invoiceDetail/invoiceDetail.vue"),
    meta: {
      title: "发票明细",
    },
  },
];
